export default __webpack_public_path__ + "2c2759e676d2083279d3079519f77f5f.jpg";